import { useQuery } from '@tanstack/react-query';
import { listBookings } from '@/v2/bookings/bookings.api.ts';
import { BookingListParams } from '@/v2/schemas.ts';

export function useBookingListQuery(params: BookingListParams) {
  return useQuery({
    queryKey: ['bookings', 'list', params],
    queryFn: async () => await listBookings(params),
  });
}
